import DrawerButton from "components/ui/DrawerButton";
import DrawerDivider from "components/ui/DrawerDivider";
import Icon from "hardcover-ui/components/Icon";
import LoadingSpinner from "hardcover-ui/components/LoadingSpinner";
import useCurrentUser from "hooks/fragments/useCurrentUser";
import faBug from "icons/regular/bug.svg";
import faClone from "icons/regular/clone.svg";
import faPencil from "icons/solid/pencil.svg";
import faTrash from "icons/solid/trash.svg";
import faAdmin from "icons/solid/user-pen.svg";
import ReportButton from "./Report/ReportButton";

export interface MenuProps {
  id: number;
  type: "Author" | "Book" | "Edition" | "Series" | "Publisher" | "Character";
  title: string;
  editLink: string;
  adminLink?: string;
  onDuplicate: () => void;
  onClose: () => void;
  deleteOption?: {
    canDelete: boolean,
    deleting: boolean;
    onDelete: () => void;
  }
}

export default function FlagMenu({
  id,
  type,
  title,
  editLink,
  adminLink,
  onDuplicate,
  onClose,
  deleteOption
}: MenuProps) {
  const admin = useCurrentUser((u) => u.librarianRoles?.includes("admin"));

  return (
    <div className="md:flex md:flex-col md:items-start">
      <DrawerButton onClick={onDuplicate}>
        <Icon
          icon={faClone}
          size="md"
        />
        <span>Flag as duplicate</span>
      </DrawerButton>

      <DrawerDivider />

      <DrawerButton
        className="p-2"
        as={{
          element: "link",
          props: { href: editLink },
        }}>
        <Icon
          icon={faPencil}
          size="md"
        />
        <span>Edit this {type.toLowerCase()}</span>
      </DrawerButton>

      <DrawerDivider />

      {deleteOption && deleteOption.canDelete &&
        <>
          <DrawerButton onClick={deleteOption.onDelete}>
            {deleteOption.deleting ? <LoadingSpinner size="sm" /> : <Icon icon={faTrash} size="md" />}
            <span>Delete this {type.toLowerCase()}</span>
          </DrawerButton>
          <DrawerDivider />
        </>
      }

      {admin && adminLink && (
        <>
          <DrawerButton
            className="p-2"
            as={{
              element: "link",
              props: {
                target: "_blank",
                rel: "noreferrer",
                href: adminLink,
              },
            }}>
            <Icon icon={faAdmin} size="md" />
            <span>Edit in admin</span>
          </DrawerButton>
          <DrawerDivider />
        </>
      )}

      <ReportButton
        drawer
        objectId={id}
        objectType={type}
        description={`${type}: '${title}'`}
        close={onClose}
      >
        <Icon icon={faBug} size="md" />
        <span>Report a problem</span>
      </ReportButton>
    </div>
  );
}
